/**
* @license Apache-2.0
*
* Copyright (c) 2018 The Stdlib Authors.
*
* Licensed under the Apache License, Version 2.0 (the "License");
* you may not use this file except in compliance with the License.
* You may obtain a copy of the License at
*
*    http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing, software
* distributed under the License is distributed on an "AS IS" BASIS,
* WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
* See the License for the specific language governing permissions and
* limitations under the License.
*/

'use strict';

/**
* Evaluate the logit function.
*
* @module @stdlib/math-base-special-logit
*
* @example
* var logit = require( '@stdlib/math-base-special-logit' );
*
* var y = logit( 0.2 );
* // returns ~-1.386
*
* y = logit( 0.9 );
* // returns ~2.197
*
* y = logit( -4.0 );
* // returns NaN
*
* y = logit( 1.5 );
* // returns NaN
*
* y = logit( NaN );
* // returns NaN
*/

// MODULES //

var main = require( './main.js' );


// EXPORTS //

module.exports = main;
